import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import { Media, MediaProps } from '@/components/base/Media'
import Motion from '@/components/base/Motion'
import Section from '@/components/base/Section'
import Typography from '@/components/base/Typography'

import { clustersRevealAnimation } from './animations'
import { WPImage } from '@/types'

export type ClustersProps = HTMLAttributes<HTMLDivElement> & {
  media: MediaProps
  title: string
  subtitle: string
  clusters: {
    card_clone: {
      icon: WPImage
      overline: string
      title: string
      text: string
    }
  }[]
}

const Clusters = ({ media, title, subtitle, clusters, ...props }: ClustersProps) => {
  return (
    <Motion animation={clustersRevealAnimation}>
      <Section {...props}>
        <Container>
          <Grid>
            <div className="col-span-4 pb-spacing-lg md:col-span-6 lg:col-span-6 lg:pr-spacing-sm">
              <Media {...media} />
            </div>
            <div className="col-span-4 flex flex-col gap-spacing-xl md:col-span-6 lg:col-span-6">
              <div className="flex flex-col gap-spacing-sm">
                <Typography variant="h4">{title}</Typography>
                <Typography variant="large" className="font-medium text-text-accent-light-dark">
                  {subtitle}
                </Typography>
              </div>
              <div className="flex flex-col gap-spacing-sm">
                {clusters.map((cluster, index) => (
                  <div
                    key={index}
                    className="flex flex-col gap-spacing-sm border-b border-solid border-white-dark/30 pb-spacing-sm last:border-0 lg:flex-row lg:gap-0"
                    data-motion-cluster
                  >
                    {cluster.card_clone?.icon?.url ? (
                      <div className="flex w-auto flex-shrink-0 flex-grow-0 items-center px-0 lg:w-[90px] lg:px-spacing-sm">
                        <img src={cluster.card_clone.icon.url} alt={cluster.card_clone.icon.alt} />
                      </div>
                    ) : null}
                    <div className="flex flex-col gap-spacing-sm">
                      <Typography variant="large" className="font-medium">
                        {cluster.card_clone.title}
                      </Typography>
                      <Typography variant="regular" className="text-text-accent-light-dark">
                        {cluster.card_clone.text}
                      </Typography>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Grid>
        </Container>
      </Section>
    </Motion>
  )
}

export default Clusters
